import { Navigate } from "../../../../../router-utils"

export default function OrganizationAutomationsIndexPage() {
	return <Navigate to={"/org/automations/definitions"} replace />
}
